<template>
  <div class="container-main-body">
    <div style="position: relative; width: 45%; height: 100%; float: left;">
      <div style="height: 30px; margin-top: 5px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addCategoryHandler">新增数据字典分类</el-button>
        <el-button type="danger" size="mini" icon="el-icon-minus" @click="delCategoryHandler">删除数据字典分类</el-button>
        <el-button type="success" size="mini" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
      <div style="position: absolute; top: 35px; right: 5px; bottom: 5px; left: 0;">
        <el-table size="mini" ref="categoryTable" :data="categories" style="width: 100%" height="100%" border highlight-current-row header-row-class-name="list-header-row" row-class-name="list-row" row-key="id" :tree-props="{children: 'children'}" @selection-change="handlerCategorySelectionChange" @current-change="handlerChangeCategory">
          <el-table-column type="selection" width="39" align="center"></el-table-column>
          <el-table-column prop="name" label="类别名称" width="200" header-align="center">
            <template v-slot:default="scope">
              <div style="padding: 0 5px;">{{scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="类别编码" width="100" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center">
            <template v-slot:default="scope">
              <div style="padding: 0 5px;">{{scope.row.remark}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="50" align="center">
            <template v-slot:default="scope">
              <el-button type="warning" size="mini" circle icon="el-icon-edit" @click="editCategoryHandler(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="position: relative; width: 55%; height: 100%; float: right;">
      <div v-if="currentCategory !== null" style="height: 30px; margin-top: 5px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addHandler">新增数据字典</el-button>
        <el-button type="success" size="mini" icon="el-icon-refresh" @click="loadDictionaries">刷新</el-button>
      </div>
      <div style="position: absolute; top: 35px; right: 0; bottom: 5px; left: 0;">
        <el-table size="mini" :data="currentCategory.dictionaries" style="width: 100%" height="100%" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handlerDictSelectionChange">
          <el-table-column type="selection" width="39" align="center"></el-table-column>
          <el-table-column prop="dict_value" label="字典值" width="200" header-align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="字典值" v-model="scope.row.dict_value"></el-input>
              <div v-else style="padding: 0 5px;">{{scope.row.dict_value}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="dict_code" label="字典编码" width="100" align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="字典编码" v-model="scope.row.dict_code"></el-input>
              <span v-else>{{scope.row.dict_code}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="70" align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="排序" v-model="scope.row.sort"></el-input>
              <span v-else>{{scope.row.sort}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" header-align="center">
            <template v-slot:default="scope">
              <el-input size="mini" v-if="scope.row.edit_status==='是'" placeholder="备注" v-model="scope.row.remark"></el-input>
              <span v-else>{{scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template v-slot:default="scope">
              <el-button v-if="scope.row.edit_status==='否'" type="warning" size="mini" circle icon="el-icon-edit" @click="scope.row.edit_status='是'"></el-button>
              <el-button v-if="scope.row.edit_status==='是'" type="success" size="mini" circle icon="el-icon-finished" @click="handlerSaveDictionary(scope.row)"></el-button>
              <el-button v-if="scope.row.edit_status==='否' || scope.row.id === '0'" type="danger" size="mini" circle icon="el-icon-minus" @click="delHandler(scope.row, scope.$index)"></el-button>
              <el-button v-if="scope.row.edit_status==='是' && scope.row.id !== '0'" type="info" size="mini" circle icon="el-icon-close" @click="scope.row.edit_status='否'"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ezz-category-dialog-form ref="CForm" :parent="this" />
  </div>
</template>
<script>
import EzzCategoryDialogForm from '@/views/modules/base/dictionary/CategoryForm.vue'
export default {
  data: function () {
    return {
      ds: [],
      emptyDictionaryData: {
        id: '0',
        category_id: '',
        dict_code: '',
        dict_value: '',
        sort: '1',
        remark: '',
        edit_status: '是'
      },
      categories: [],
      selectedCategoryIds: [],
      selectedIds: [],
      currentCategory: {
        id: '0',
        dictionaries: []
      },
      operator_id: sessionStorage.getItem('operator_id')
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getDictCategories, {}, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          _this.categories = _json.datalist
          _this.$refs.categoryTable.setCurrentRow(_this.categories[0])
        }
      })
    },
    loadDictionaries: function () {
      let _this = this
      _this.post(_this.$apis.getDictionaries, { categoryId: _this.currentCategory.id }, function (res) {
        let _json = res.data
        _this.currentCategory.dictionaries = _json.dataList
      })
    },
    // 新增数据字典类别
    addCategoryHandler: function () {
      this.$refs.CForm.addHandler()
    },
    editCategoryHandler: function (_row) {
      this.$refs.CForm.editHandler(_row.id)
    },
    // 删除数据字典类别
    delCategoryHandler: function (_row) {
      let _this = this

      if (_this.selectedCategoryIds.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let _params = {
            ids: _this.selectedCategoryIds.join(','),
            operator_id: _this.operator_id
          }
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delDictCategory, _params, function (res) {
            let _json = res.data
            if (_json.status === 'ok') {
              _this.loadData()
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              _this.$message({
                type: 'error',
                message: '无数据更新!'
              })
            }
          })
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 数据字典类别 行选择事件
    handlerChangeCategory: function (_newRow, _oldRow) {
      this.currentCategory = _newRow
      this.currentCategory.dictionaries = _newRow.dictionaries
    },
    // 数据字典类别 checkbox选择事件
    handlerCategorySelectionChange: function (selection) {
      this.selectedCategoryIds = []
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedCategoryIds.push(selection[_i].id)
      }
    },
    /**********************************************/
    // 新增数据字典
    addHandler: function () {
      const newDictionary = JSON.parse(JSON.stringify(this.emptyDictionaryData))
      newDictionary.category_id = this.currentCategory.id
      newDictionary.sort = this.currentCategory.dictionaries.length + 1
      this.currentCategory.dictionaries.unshift(newDictionary)
    },
    delHandler: function (_row, _index) {
      let _this = this
      _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (_row.id === '0') {
          _this.$delete(_this.currentCategory.dictionaries, _index)
        } else {
          let _params = {
            ids: _row.id,
            categoryId: _this.currentCategory.id,
            operator_id: _this.operator_id
          }
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delDictionaries, _params, function (res) {
            let _json = res.data
            if (_json.status === 'ok') {
              _this.currentCategory.dictionaries = _json.dictionaries
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              _this.$message({
                type: 'error',
                message: '无数据更新!'
              })
            }
          })
        }
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 多选数据字典事件
    handlerDictSelectionChange: function (selection) {
      this.selectedIds = []
      for (let _i = 0; _i < selection.length; ++_i) {
        this.selectedIds.push(selection[_i].id)
      }
    },
    handlerSaveDictionary: function (row) {
      let _this = this
      if (row.dict_value === '') {
        _this.$message({
          type: 'error',
          message: '字典值不能为空'
        })
        return false
      }
      row.operator_id = _this.operator_id
      _this.post(_this.$apis.saveDictionary, row, function (res) {
        let _json = res.data
        if (_json.status === 'ok') {
          _this.$message({
            message: '保存成功',
            type: 'success'
          })
          _this.loadDictionaries()
        }
      })
    },
    // 刷新事件
    refreshHandler: function () {
      this.loadData()
    }
  },
  components: {
    EzzCategoryDialogForm
  }
}
</script>
